module.exports = __webpack_public_path__ + "img/custom-select.33d0b67c.png";